import { showToast } from "~/ui-kit/utils/useToast";

export default defineNuxtPlugin(() => {
	return {
		provide: {
			openToast: showToast,
		},
	};
});
